import { render, staticRenderFns } from "./LoyaltyPostsCard.vue?vue&type=template&id=bfc0917a&"
import script from "./LoyaltyPostsCard.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPostsCard.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPostsCard.vue?vue&type=style&index=0&id=bfc0917a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContinueMyShoppingLink: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ContinueMyShoppingLink.vue').default})
